import axios from "axios";
import config from "../config/config";

const generateResponse = (isSuccess, data, error) => {
  return {
    isSuccess,
    data,
    error,
  };
};

export const axiosCall = async (method, url, data, params, token, header) => {
  try {
    let headers = {};
    if (token) {
      headers = { Authorization: `Bearer ${token}` };
    }

    if(header){
      headers = {...headers, ...header}
    }

    let response = await axios({
      method,
      url: `${config.server.url}/apis/${url}`,
      data,
      params,
      headers,
    });
    if (response.status === 200) {
      return generateResponse(true, response.data);
    }
  } catch (error) {
    const status = error?.response?.status;
    const respData = error?.response?.data;

    // If server responded with a known error status, surface it.
    if ([400, 401, 404, 409, 429, 500].includes(status)) {
      if (respData) {
        return generateResponse(false, null, respData);
      }
      return generateResponse(false, null, { message: `Request failed with status ${status}` });
    }

    // If it's a network/CORS/preflight error, `error.response` can be undefined.
    return generateResponse(false, null, {
      message: error?.message || "Request failed. Please try again.",
    });
  }
};